import { Box, Chip, Divider, Grid2, Paper, Typography } from '@mui/material';
import React, { FC, useMemo } from 'react';
import * as Yup from 'yup';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { CreateArtsUseCase } from '../../../Usecase/Arts/create-arts-usecase';
import { ShowArtsUseCase } from '../../../Usecase/Arts/show-arts-usecase';
import { useCreateOrdersSingleList } from './orders-single-create.hook';
import SelectCustomerVariant from '../../../Components/Modals/variants/select-customer/select-customer-variant.component';
import { ListCustomersUseCase } from '../../../Usecase/Customers/list-customers-usecase';
import SelectProductVariant from '../../../Components/Modals/variants/select-product/select-product-variant.component';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { SelectComponent } from '../../../Components/Form/Select/select.component';
import { Flex } from '../../../Components/Flex/flex.component';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { Environment } from '../../../Config/constants';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { InputCurrency } from '../../../Components/Form/InputCurrency/input-currency.component';
  

  interface IOrdersSingleFormProps {
    createArtsUseCase: CreateArtsUseCase
    showArtsUseCase: ShowArtsUseCase
    listCustomersUseCase: ListCustomersUseCase
    listProductsUseCase: ListProductUseCase
    // updateArtsUseCase: UpdateArtsUseCase
  }


const OrdersSingleForm : FC<IOrdersSingleFormProps> = ({ createArtsUseCase, showArtsUseCase, listCustomersUseCase, listProductsUseCase  }) => {

    const {handleAction, handleSubmit, loading, register,setShowCustomersModal, showCustomersModal, errors, data, customerSelected, setCustomerSelected, handleSelectCustomer, handleSelectProduct,
        setShowProductsModal, showProductsModal, productsSelected, control, address, handleAddNewPayment, payments, typePayment, watch, cardBrand } = useCreateOrdersSingleList({
      createArtsUseCase,
      showArtsUseCase,
      
    })

    const columnsProducts = useMemo(() => {
        const createColumns: any[] = [
          {
            field: 'photo',
            headerName: 'Imagem',
            renderCell: (params: any) => <Box component='img' src={params?.row?.images[0]?.link || Environment.IMAGE_PLACEHOLDER} sx={{ width: '80px', height: '80px', objectFit: 'contain'}} />
          },
          {
            field: 'name',
            flex: 1,
            headerName: 'Produto',
          },
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "right",
            flex: 1,
            renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={() => {}} editLink={`/products-form/${params.row.id}`} />
          }
        ];
      
        return createColumns;
      }, []);



    
    return (
        <BaseScreen>
        {showCustomersModal && <SelectCustomerVariant data={[]} onClose={() => setShowCustomersModal(false)} onSearch={() => {}} onSelect={handleSelectCustomer} listCustomersUseCase={listCustomersUseCase} />}

        {showProductsModal && <SelectProductVariant data={[]} onClose={() => setShowProductsModal(false)} onSearch={() => {}} onSelect={handleSelectProduct} listProductsUseCase={listProductsUseCase} />}
         
            <Paper >
                <BaseContentPage 
                    title='Pedidos de Venda (Avulso)'
                    breadcrumb={[{ title: 'Pedidos de Venda (Avulso)', link: "/orders-single-form"}, { title: 'Novo Pedido'}]}
                >

                {loading && <Loader />}

                <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>


                <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Cliente</Typography>
                    <Grid2 size={12} container sx={{
                        width: '100%',
                        padding: '20px',
                        border: '2px dashed #ccc',
                        borderRadius: '8px',
                        marginTop: -4
                    }}>
                      

                        <Grid2 size={12} container spacing={2}>
                            {!!customerSelected?.id ?  <Chip   
                                label={customerSelected?.name} 
                                onDelete={() => setCustomerSelected(undefined)} 
                                sx={{ fontSize: '14px'}}
                            /> : <Typography>Nenhum cliente selecionado.</Typography>}
                        
                        </Grid2>

                    <Grid2 size={12}>
                    <Button onClick={() => setShowCustomersModal(true)} sx={{ width: '300px' }} isLoading={loading}>
                        Selecionar Cliente
                    </Button>
                    </Grid2>

                </Grid2>


                <Grid2 size={6}>
                    <SelectComponent 
                        label='Endereço de Cobrança' 
                        options={address} 
                        control={control} 
                        // error={!!errors.boxId} 
                        placeholder=''
                        // helperText={errors?.boxId?.message || ''} 
                        {...register('charge_address')} 
                    />          
                </Grid2>

                <Grid2 size={6}>
                    <SelectComponent 
                        label='Endereço de Entrega' 
                        options={address} 
                        control={control} 
                        // error={!!errors.boxId} 
                        placeholder=''
                        // helperText={errors?.boxId?.message || ''} 
                        {...register('delivery_address')} 
                    />          
                </Grid2>


                <Grid2 size={12} mt='50px'>
                    <Flex justifyContent='space-between' alignItems='center'>
                        <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Pagamentos</Typography>
                        <Button 
                            variant='outlined' 
                            // onClick={() => setShowProductsModal(true)} 
                            onClick={handleAddNewPayment} 
                            sx={{ width: '320px' }} 
                            isLoading={loading}
                        >Adicionar Forma de Pagamento</Button>
                    </Flex>
                    <Divider sx={{ margin: '10px 0'}} />

                
                    
                    <Grid2 size={12}>
                            {payments?.length ? payments?.map((i, index) => (
                                <Grid2 size={12} container spacing={2} marginTop='20px' borderBottom='solid 1px #ccc' paddingBottom='15px'>
                                    <Grid2 size={0.2}>
                                        <Flex height='100%' alignItems='center'>
                                            <Typography>{index + 1}.</Typography>
                                        </Flex>
                                       
                                    </Grid2>
                                     <Grid2 size={3}>
                                        <SelectComponent 
                                            label='Tipo de Pagamento' 
                                            options={typePayment} 
                                            control={control} 
                                            // error={!!errors.boxId} 
                                            placeholder=''
                                            // helperText={errors?.boxId?.message || ''} 
                                            {...register(`payment-type-${i.id}`)} 
                                        />  
                                     </Grid2>

                                     {watch(`payment-type-${i.id}`) === 'card' &&  <Grid2 size={2}>
                                        <SelectComponent 
                                            label='Bandeira' 
                                            options={cardBrand} 
                                            control={control} 
                                            // error={!!errors.boxId} 
                                            placeholder=''
                                            // helperText={errors?.boxId?.message || ''} 
                                            {...register(`payment-brand-${i.id}`)} 
                                        />  
                                     </Grid2> }
                                    

                                    <Grid2 size={1}>
                                        <Input
                                            label="Parcela"
                                            placeholder="Parcela"
                                            // error={!!errors.}
                                            // helperText={errors.artLink?.message}
                                            {...register(`payment-installment-${i.id}`)}
                                        />
                                    </Grid2>

                                   

                                    {/* <Grid2 size={3}>
                                        <InputCurrency
                                            label="Valor total"
                                            placeholder="Valor total do pagamento"
                                            // error={!!errors.}
                                            // helperText={errors.artLink?.message}
                                            {...register(`payment-price-${i.id}`)}
                                        />
                                    </Grid2> */}

                                    {watch(`payment-type-${i.id}`) === 'card' && (
                                        <Grid2 size={2}>
                                            <Input
                                                label="Código Conciliadora"
                                                placeholder="Preencha o código"
                                                // error={!!errors.}
                                                // helperText={errors.artLink?.message}
                                                {...register(`payment-cod-${i.id}`)}
                                            />
                                        </Grid2>
                                    )}
                                    

                                </Grid2>
                            ))  :  <Placeholder description='Nenhum método de pagamento adicionado' sx={{ marginTop: '80px'}} /> }
                    </Grid2>

                   

                </Grid2>


                <Grid2 size={12} mt='50px'>
                    <Flex justifyContent='space-between' alignItems='center'>
                        <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Produtos</Typography>
                        <Button variant='outlined' onClick={() => setShowProductsModal(true)} sx={{ width: '230px' }} isLoading={loading}>Adicionar Produto</Button>
                    </Flex>
                  
                    <Divider sx={{ margin: '10px 0'}} />

                    {productsSelected?.length ?  <Table data={productsSelected} columns={columnsProducts} totalCount={0} pagination={false} isRowSelectable={() => false} disableRowSelectionOnClick={false} /> : <Placeholder description='Nenhum produto adicionado' sx={{ marginTop: '80px'}} />}

                   

                   

                </Grid2>



                {/* <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Produto</Typography>
                    <Grid2 size={12} container sx={{
                        width: '100%',
                        padding: '20px',
                        border: '2px dashed #ccc',
                        borderRadius: '8px',
                        marginTop: -4
                    }}>
                      

                        <Grid2 size={12} container spacing={2}>
                            {!!productSelected?.id ?  <Chip   
                                label={productSelected?.name} 
                                onDelete={() => setCustomerSelected(undefined)} 
                                sx={{ fontSize: '14px'}}
                            /> : <Typography>Nenhum produto selecionado.</Typography>}
                        
                        </Grid2>

                    <Grid2 size={12}>
                    <Button onClick={() => setShowProductsModal(true)} sx={{ width: '300px' }} isLoading={loading}>
                        Selecionar Produto
                    </Button>
                    </Grid2>

                </Grid2> */}

               

                
              

                <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                    SALVAR
                </Button>
                </Grid2>

              </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
    )
}

export { OrdersSingleForm };
